import { gql } from 'apollo-angular'

export const FORGOT_PASSWORD = gql`
  mutation forgotPasswordUser($email: String!) {
    forgotPasswordUser(email: $email)
  }
`
